import { render } from "./IsletSpecificSectionDetailsEMROATS.vue?vue&type=template&id=54d8aeaa&scoped=true"
import script from "./IsletSpecificSectionDetailsEMROATS.vue?vue&type=script&lang=js"
export * from "./IsletSpecificSectionDetailsEMROATS.vue?vue&type=script&lang=js"

import "./IsletSpecificSectionDetailsEMROATS.vue?vue&type=style&index=0&id=54d8aeaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d8aeaa"],['__file',"src/components/IsletSpecificSectionDetailsEMROATS.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54d8aeaa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54d8aeaa', __exports__)) {
    api.reload('54d8aeaa', __exports__)
  }
  
  module.hot.accept("./IsletSpecificSectionDetailsEMROATS.vue?vue&type=template&id=54d8aeaa&scoped=true", () => {
    api.rerender('54d8aeaa', render)
  })

}


export default __exports__